import React from 'react';
import { Toolbar, Button, Typography, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { PVMediumPurple } from '@pv/common/colors';
import { BANNER_HEIGHT, useNavLayout } from '../NavLayoutContext';

const SubscriptionStatusBar = () => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();
  const { pastDueBannerVisible } = useNavLayout();

  const onClick = () => {
    navigate(`/settings/organization`);
  };

  if (pathname.match(/^\/onboarding/)) {
    return null;
  }

  if (!pastDueBannerVisible) {
    return null;
  }

  return (
    <Toolbar
      sx={{
        backgroundColor: PVMediumPurple,
        height: BANNER_HEIGHT,
        minHeight: BANNER_HEIGHT,
        justifyContent: 'center',
      }}
    >
      <Typography color="white" style={{ margin: theme.spacing(0, 2) }}>
        💳{' '}
        <strong style={{ marginLeft: theme.spacing(0.5) }}>
          Subscription payment failed. Please update the payment method on file.
        </strong>
      </Typography>
      <Button
        size="small"
        color="secondary"
        sx={{
          marginRight: '16px',
        }}
        onClick={onClick}
        variant="contained"
      >
        Update Card on File
      </Button>
    </Toolbar>
  );
};

export default SubscriptionStatusBar;
